import { render, staticRenderFns } from "./BlogPostContent.vue?vue&type=template&id=67b23d8c"
import script from "./BlogPostContent.vue?vue&type=script&lang=js"
export * from "./BlogPostContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports